module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "activityCompletion hintDialog flexcenter",
    class: _vm.isHintHosoku ? 'hintHosoku' : ''
  }, [_c('transition', [_c('div', {
    staticClass: "activity flexcenter"
  }, [_c('div', {
    staticClass: "activityContent"
  }, [_c('div', {
    staticClass: "hintBox flexcenter"
  }, [_c('div', {
    staticClass: "item"
  }, [(_vm.isHintHosoku) ? _c('p', [_vm._v(_vm._s(_vm.hintText))]) : _c('p', [_vm._v("ヒント：" + _vm._s(_vm.hintText)), _c('br'), _c('br'), _vm._v("ドラッグ アンド ドロップの操作は不要です。")])])])]), _vm._v(" "), _c('div', {
    staticClass: "activityResetFooter"
  }, [_c('div', {
    staticClass: "buttons flexbetween"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clickButton()
      }
    }
  }, [_vm._v(_vm._s(_vm.buttonText))])])])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5b725446", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-5b725446","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HintDialog.vue
// module id = 868
// module chunks = 1